<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";


import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {


  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader,

  },
  data() {

    return {
      title: "Base Cotação Fretes TDE",
      items: [
        {
          text: "Administrativo",
          href: "/"
        },
        {
          text: "Base Cotação Fretes TDE",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,


      errosValid: null,
      focusedRowKey: null,

    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {


    excluirBaseTde(){
      console.log('excluirBaseTde')
      console.log(this.focusedRowKey)
      // console.log('deletar: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.delete(`${getBaseUrl()}api/fretecotabasetde`, {
            params: {
              'iddata': this.focusedRowKey
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.atualizaDataList()
          })
        }
      })
    },


    novaBaseTde(){
      console.log('novaBaseTde')
      this.$router.push('/cotacaofretesbasetde/editar/0')
    },



    carregouGrid(e){
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ') Bases Cotação Fretes TDE'
    },


    atualizaDataList(){
      console.log('atualizaDataList_mov')
      console.log(this.exibEmit)


      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions){


          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/fretecotabasestde`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row)
      this.$router.push('/cotacaofretesbasetde/editar/' + row.data.id)
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.status)
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'A':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'I':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeCanal(e) {
      switch (e.value) {
        case 'PU':
          return 'Pusher'

      }
      return 'Não Definido'
    },



    nomeStatus(e) {
      if (e.value === "A") {
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    },

  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Importar arquivo de movimento"
              text="Nova Base"
              :on-click="novaBaseTde"/>

        </DxItem>




      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">



      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          v-model:focused-row-key="focusedRowKey"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />



        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strOcorFinalsList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            data-field="id"
            sort-order="desc"
            caption="ID"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="descricao"
            caption="Descrição"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="tdeperc"
            caption="TDE(%)"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="tdemin"
            caption="TDE Mín."
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="tdemax"
            caption="TDE Máx."
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="tdefixo"
            caption="TDE Fixo"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>


        <DxColumn
            data-field="created_at"
            caption="Criado"
            alignment="right"
            data-type="datetime"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>



  </Layout>
</template>
